import React, { useState } from "react";
import Slider from "react-slick";
import { motion, AnimatePresence } from "framer-motion";

const testimonials = [
  {
    id: 1,
    name: "John",
    text: "MH Cockpit provided me with the best aviation learning experience. Their instructors are world-class, and the facilities are top-notch!",
    image: "https://mhcockpit.com/Media/4%20Aviators/Home/testi.jpg",
  },
  {
    id: 2,
    name: "Sarah Williams",
    text: "An excellent program that truly prepares you for real-world aviation challenges. The community is also very supportive.",
    image: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=600&q=80",
  },
  {
    id: 3,
    name: "David Johnson",
    text: "From modern aircraft to expert instructors, MH Cockpit exceeded all my expectations. Highly recommend it to anyone pursuing aviation!",
    image: "https://images.unsplash.com/photo-1603415526960-f7e0328c63b1?auto=format&fit=crop&w=600&q=80",
  },
];

const TestimonialCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_, next) => setActiveIndex(next),
  };

  return (
    <div className="relative w-full h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image Transition */}
      <AnimatePresence mode="wait">
        <motion.div
          key={testimonials[activeIndex].id}
          className="absolute inset-0 bg-cover bg-center transition-all duration-700"
          style={{
            backgroundImage: `url(${testimonials[activeIndex].image})`,
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        ></motion.div>
      </AnimatePresence>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Top Right Text */}
      <h2 className="absolute top-6 right-6 text-white/30 text-3xl font-semibold tracking-widest select-none">
        TESTIMONIALS
      </h2>

      {/* Carousel Content */}
      <div className="relative z-10 max-w-5xl w-full px-6 py-10">
        <Slider {...settings}>
          {testimonials.map((t) => (
            <div key={t.id}>
              <div className="flex flex-col md:flex-row items-center gap-6 bg-white/10 backdrop-blur-md rounded-2xl p-6 shadow-lg">
                {/* Left Image */}
                <div className="flex-shrink-0 w-full md:w-1/3">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="rounded-xl w-full h-64 object-cover shadow-md"
                  />
                </div>

                {/* Right Text */}
                <div className="text-white md:w-2/3 text-center md:text-left">
                  <h3 className="text-2xl font-semibold">{t.name}</h3>
                  <p className="text-lg md:text-xl italic mb-4 leading-relaxed">
                    “{t.text}”
                  </p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default TestimonialCarousel;
